import { useState, useEffect } from 'react'

interface PrivacySection {
  id?: number
  section: string
  title: string
  content: string
  is_active?: number
}

const PrivacyPolicy = () => {
  const [sections, setSections] = useState<PrivacySection[]>([])
  const [loading, setLoading] = useState(true)

  const API_BASE = 'https://lmtseva.com/api'

  // Fetch all active sections
  const fetchSections = async () => {
    setLoading(true)
    try {
      const response = await fetch(`${API_BASE}/privacy_list.php`)
      const result = await response.json()
      
      if (result.status && result.data) {
        // Handle both array and object response formats
        let sectionsArray: PrivacySection[] = []
        if (Array.isArray(result.data)) {
          sectionsArray = result.data
        } else {
          // Convert object to array
          sectionsArray = Object.values(result.data) as PrivacySection[]
        }
        // Filter only active sections and sort by section ID
        const activeSections = sectionsArray
          .filter((s: PrivacySection) => (s.is_active ?? 1) === 1)
          .sort((a, b) => {
            // Sort by section ID (e.g., section_1, section_2)
            const aNum = parseInt(a.section.replace('section_', '')) || 0
            const bNum = parseInt(b.section.replace('section_', '')) || 0
            return aNum - bNum
          })
        setSections(activeSections)
      }
    } catch (err) {
      console.error('Error fetching privacy sections:', err)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchSections()
  }, [])

  return (
    <div className="min-h-screen bg-gray-900">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-gray-800 to-gray-900 py-20">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
              Privacy Policy
            </h1>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16 md:py-24">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            {loading ? (
              <div className="bg-gray-800 rounded-lg p-12 text-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-light mx-auto mb-4"></div>
                <p className="text-gray-400 text-lg">Loading privacy policy...</p>
              </div>
            ) : sections.length === 0 ? (
              <div className="bg-gray-800 rounded-lg p-12 text-center">
                <p className="text-gray-400 text-lg">No privacy policy available at this time.</p>
              </div>
            ) : (
              sections.map((section, index) => (
                <div key={section.id || index} className="bg-gray-800 rounded-lg p-8 md:p-12 mb-8">
                  <h2 className="text-2xl md:text-3xl font-bold text-white mb-6">
                    {section.title}
                  </h2>
                  <div 
                    className="text-gray-300 text-lg md:text-xl leading-relaxed"
                    dangerouslySetInnerHTML={{ __html: section.content }}
                  />
                </div>
              ))
            )}
          </div>
        </div>
      </section>
    </div>
  )
}

export default PrivacyPolicy

